export enum ETAType {
  SAP        = 'SAP',
  BLUEYONDER = 'BLUEYONDER',
  CARRIER    = 'CARRIER',
  AUTOMATIC  = 'AUTOMATIC',
  DYNAMIC    = 'DYNAMIC',
  FOURKITES  = 'FOURKITES'
}
